export const SEARCH_CHECK_DEBOUNCE_AMOUNT = 300

export const SEARCH_ID = 'search_id'
